import axios from "./axios";

// Journal API functions
export const fetchJournals = async (controller = {}) => {
  try {
    const params = new URLSearchParams();

    // Add controller parameters
    if (controller.page) params.append("page", controller.page);
    if (controller.per_page) params.append("per_page", controller.per_page);
    if (controller.query) params.append("query", controller.query);
    if (controller.status) params.append("status", controller.status);
    if (controller.module_type)
      params.append("module_type", controller.module_type);
    if (controller.module_param)
      params.append("module_param", controller.module_param);
    if (controller.module_record_type)
      params.append("module_record_type", controller.module_record_type);
    if (controller.module_record_id != null && controller.module_record_id !== "")
      params.append("module_record_id", controller.module_record_id);
    if (controller.start_date)
      params.append("start_date", controller.start_date);
    if (controller.end_date) params.append("end_date", controller.end_date);
    if (controller.fields) params.append("fields", controller.fields);

    const response = await axios.get(`/journals?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching journals:", error);
    throw error;
  }
};

export const fetchJournal = async (id, fields = null) => {
  try {
    const params = new URLSearchParams();
    if (fields) params.append("fields", fields);

    const response = await axios.get(
      `/journals/${id}?${params.toString()}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching journal:", error);
    throw error;
  }
};

export const createJournal = async (journalData) => {
  try {
    const response = await axios.post("/journals", {
      journal: journalData,
    });
    return response.data;
  } catch (error) {
    console.error("Error creating journal:", error);
    throw error;
  }
};

export const updateJournal = async (id, journalData) => {
  try {
    const response = await axios.put(`/journals/${id}`, {
      journal: journalData,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating journal:", error);
    throw error;
  }
};

export const deleteJournal = async (id) => {
  try {
    await axios.delete(`/journals/${id}`);
    return { success: true };
  } catch (error) {
    console.error("Error deleting journal:", error);
    throw error;
  }
};

// Helper function to create journal for specific module
export const createJournalForModule = async (
  moduleType,
  moduleParam,
  journalData
) => {
  const data = {
    ...journalData,
    module_type: moduleType,
    module_param: moduleParam,
  };
  return createJournal(data);
};
